import { request } from '../axios/request';

import {
  DETECTING_OUT_OF_STOCK_PENDING,
  DETECTING_OUT_OF_STOCK_REJECTED,
  DETECTING_OUT_OF_STOCK_FULFILLED,
} from '../constants/detectingOutOfStock';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: DETECTING_OUT_OF_STOCK_PENDING,
});

const fulfilled = (response) => ({
  type: DETECTING_OUT_OF_STOCK_FULFILLED,
  response,
});

const rejected = (error) => ({
  type: DETECTING_OUT_OF_STOCK_REJECTED,
  error,
});

export const detectingOutOfStock =
  (packageOrderId, selectedIds, actionParams, extraParams = {}) =>
  (dispatch) => {
    const { id: transition, source_state, destination_state } = actionParams;
    const url = OMS.OMS.PACKAGE_ORDER_DETAIL_COMMAND.replace(
      '{0}',
      packageOrderId
    );

    const data = {
      input_parameters: {
        package_items: selectedIds,
      },
      transition,
      source_state,
      destination_state,
      ...extraParams,
    };

    dispatch(pending());
    request({
      method: 'POST',
      url,
      data,
    })
      .then((response) => {
        dispatch(fulfilled(response));
      })
      .catch((error) => {
        dispatch(rejected({ apiError: error }));
      });
  };



// WEBPACK FOOTER //
// ./src/actions/detectingOutOfStock.js